import React from 'react';
import { motion } from 'framer-motion';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Loader2 } from 'lucide-react';

const TasksByStatusChart = ({ data, isLoading }) => {
  const totalTasks = data.reduce((sum, item) => sum + item.count, 0);

  const statusColors = {
    'To Do': 'bg-slate-500',
    'In Progress': 'bg-blue-500',
    'Done': 'bg-green-500',
    'Blocked': 'bg-red-500',
    'Review': 'bg-yellow-500',
  };

  return (
    <Card className="bg-slate-800/70 border-slate-700 shadow-lg">
      <CardHeader>
        <CardTitle className="text-lg font-semibold text-slate-200">Tasks by Status</CardTitle>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="flex items-center justify-center h-40">
            <Loader2 className="h-8 w-8 text-slate-400 animate-spin" />
          </div>
        ) : (
          <div className="space-y-3">
            {data.length === 0 && <p className="text-slate-400">No task data available.</p>}
            {data.map((item, index) => {
              const percentage = totalTasks > 0 ? (item.count / totalTasks) * 100 : 0;
              const color = statusColors[item.name] || 'bg-gray-400';
              return (
                <motion.div
                  key={item.name}
                  initial={{ opacity: 0, x: -20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.3, delay: index * 0.1 }}
                  className="space-y-1"
                >
                  <div className="flex justify-between text-sm text-slate-300">
                    <span>{item.name}</span>
                    <span>{item.count} ({percentage.toFixed(1)}%)</span>
                  </div>
                  <div className="w-full bg-slate-700 rounded-full h-2.5">
                    <motion.div
                      className={`${color} h-2.5 rounded-full`}
                      initial={{ width: 0 }}
                      animate={{ width: `${percentage}%` }}
                      transition={{ duration: 0.5, ease: "easeOut", delay: index * 0.1 + 0.2 }}
                    />
                  </div>
                </motion.div>
              );
            })}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default TasksByStatusChart;